// extracted by mini-css-extract-plugin
export default {"mainContent":"Home_mainContent__VsRHF"};